<template>
  <el-container id="app">
    <el-header v-if="showHeader">
      <app-header v-bind:is-user-logged="isUserLogged"></app-header>
    </el-header>
    <router-view></router-view>
  </el-container>
</template>

<script>
import AppHeader from '@/components/AppHeader';

export default {
  name: 'app',
  components: {
    'app-header': AppHeader,
  },
  data() {
    return {
      isUserLogged: true,
      menuIsVisible: false,
      clientView: false,
    };
  },
  computed: {
    showHeader: function() {
      return this.$route.path !== '/cliente' && !this.$route.path.startsWith('/imprimir-analisis-portafolio')
    }
  },
  created: function () {
    this.clientView = this.$route.path === '/cliente'
    const existSession = localStorage.getItem('token')
    const userId = localStorage.getItem('user_id')
    if (existSession && userId) {
      if (this.$route.path !== '/seccion-de-pruebas' && this.$route.name !== 'PrintablePortfolioAnalysis') {
        this.$router.push('/lista-de-analisis')
      }
    } else if (this.$route.path !== '/cliente') {
      this.$router.push('/')
    }
  }
};
</script>

<style>

html, body {
  height: 100%;
}

body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
}

#app {
  max-width: 1366px;
  margin: 0 auto;
  display: block;
}

.el-header {
  background-color: white;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0 20px;
}
.detail-title {
  font-size: 20px !important;
  font-weight: 600 !important;
}
.el-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.el-main {
  color: #333;
  text-align: center;
  line-height: 160px;
}

.el-textarea__inner {
  width: 100% !important;
}
@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 812px)
and (-webkit-device-pixel-ratio : 3) { /* STYLES GO HERE */
  body {
    zoom: 0.6;
  }
}

@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 667px) 
and (orientation : landscape) { /* STYLES GO HERE */
  body {
    zoom: 0.6;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue